import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import partnersHero from "../assets/img/hero-banners/academic-partners-hero.png";

import alphaLogo from "../assets/img/academic-partners/alpha-foundation.webp";

import diu from "../assets/img/mous/diu-logo.png";
import indiana from "../assets/img/mous/indiana-logo.png";
import rushford from "../assets/img/mous/rushford-logo.webp";
import henry from "../assets/img/mous/henry-logo.png";


const partners = [
    {
        number: "01",
        name: "Alpha Foundation",
        category: "NGO Partner",
        location: "India",
        logo: alphaLogo,
        intro:
            "Alpha Foundation is a government registered NGO, determined to funding, footing and sustaining actual grassroots initiatives focused at providing learning and wellbeing to disadvantaged children. In this process, the foundation has achieved position as the first ever grant maker and changing the face of thousands of lives.",
        description:
            "Alpha Foundation aims at Welfare Reforms for underprivileged children, Social welfare and Health Welfare. It is an Indian NGO for Social Services, Indian Child Welfare Services, Child Education and Self Employment.",
        highlights: [
            "Child Education",
            "Social Welfare",
            "Health Welfare",
            "Self Employment",
        ],
        theme: "light",
    },
    {
        number: "02",
        name: "Dresden INTERNATIONAL University GmbH",
        category: "International Academic Collaboration",
        location: "Dresden, Germany",
        logo: diu,
        intro:
            "ISBM University has signed a MoU with Dresden International University, Dresden, Germany. The MoU will pave the way for students to enroll and get a comprehensive knowledge and skills in market oriented programmes such as MSC and MBA in Logistics Management, International Commercial and Contract Management, Industrial Management in Microelectronics, Non-Destructive Testing, among others with work opportunities post-study tenure.",
        highlights: [
            "Logistics Management",
            "International Commercial & Contract Management",
            "Industrial Management in Microelectronics",
            "Non-Destructive Testing",
        ],
        theme: "navy",
    },
    {
        number: "03",
        name: "Rushford Business School",
        category: "Dual Degree Partnership",
        location: "Switzerland",
        logo: rushford,
        intro:
            "ISBM University and Rushford Business School are pleased to announce a new partnership to offer students a global business education. This partnership will allow students to earn a dual degree from both universities, one from ISBM University in India and one from Rushford Business School in Switzerland.",
        highlights: [
            "Global Business Education",
            "Dual Degree Opportunity",
            "India",
            "Switzerland",
        ],
        theme: "burgundy",
    },
    {
        number: "04",
        name: "Henry Harvin",
        category: "Training & Placement Partner",
        location: "US & India",
        logo: henry,
        intro:
            "ISBM University has signed a Memorandum of Understanding (MoU) with Henry Harvin®, a global Edtech Company based out of US and India, to conduct Training and Placement programmes for its Students in over 600+ courses available with the Edtech company like Six Sigma Green Belt, Tableau, Analytics using Python/R (Business, Marketing, HR, Finance), Blockchain Professional Course, Data Science with Python Course, etc. The objective of the MoU is to offer on-the-job training and practical training to students of either diploma, graduation or post graduation in any stream to enhance their employability and counter the issues with respect to skilled labour scarcity in the region.",
        highlights: [
            "Training & Placement",
            "Practical Training",
            "Employability Development",
        ],
        theme: "blue",
    },
    {
        number: "05",
        name: "Indiana Tech University",
        category: "Academic Partnership",
        location: "International",
        logo: indiana,
        intro:
            "Our partnership with Indiana Tech signifies a commitment to providing our students with a broader perspective and access to a wider range of academic opportunities. This collaboration opens the door to exchange programmes, joint research initiatives, and shared resources, allowing students from both institutions to benefit from a richer educational experience.",
        highlights: [
            "Exchange Programmes",
            "Joint Research",
            "Shared Resources",
            "Academic Opportunities",
        ],
        theme: "ivory",
    },
];


export default function AcademicPartners() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* ====================================================== */}
                {/* HERO */}
                {/* ====================================================== */}

                <section className="relative min-h-[60vh] overflow-hidden bg-[#071A2F] text-white lg:min-h-[60vh]">

                    <img src={partnersHero} alt="ISBM University academic partnerships" className="absolute inset-0 h-full w-full object-cover" />

                    <div className="absolute inset-0 bg-gradient-to-r from-[#071A2F] via-[#071A2F]/92 to-[#071A2F]/25" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#071A2F]/85 via-transparent to-[#071A2F]/15" />

                    {/* UNIQUE PARTNERSHIP NETWORK */}
                    <div className="pointer-events-none absolute right-[5%] top-[18%] hidden h-[370px] w-[420px] lg:block">

                        <div className="absolute left-1/2 top-1/2 h-[88px] w-[88px] -translate-x-1/2 -translate-y-1/2 rounded-full border border-white/25 bg-[#071A2F]/70 backdrop-blur-md">

                            <div className="grid h-full w-full place-items-center text-center">

                                <span className="text-[10px] font-bold uppercase leading-4 tracking-[0.16em] text-[#D5AD57]">
                                    ISBM
                                    <br />
                                    University
                                </span>

                            </div>

                        </div>


                        <div className="absolute left-1/2 top-[25px] h-[128px] w-px -translate-x-1/2 bg-white/20" />
                        <div className="absolute bottom-[25px] left-1/2 h-[128px] w-px -translate-x-1/2 bg-white/20" />
                        <div className="absolute left-[60px] top-1/2 h-px w-[125px] bg-white/20" />
                        <div className="absolute right-[60px] top-1/2 h-px w-[125px] bg-white/20" />

                        <div className="absolute left-1/2 top-0 -translate-x-1/2 rounded-full border border-white/20 bg-[#071A2F]/80 px-5 py-3 backdrop-blur-md">

                            <span className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/65">
                                Germany
                            </span>

                        </div>

                        <div className="absolute bottom-0 left-1/2 -translate-x-1/2 rounded-full border border-white/20 bg-[#071A2F]/80 px-5 py-3 backdrop-blur-md">

                            <span className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/65">
                                Switzerland
                            </span>

                        </div>

                        <div className="absolute left-0 top-1/2 -translate-y-1/2 rounded-full border border-white/20 bg-[#071A2F]/80 px-5 py-3 backdrop-blur-md">

                            <span className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/65">
                                India
                            </span>

                        </div>

                        <div className="absolute right-0 top-1/2 -translate-y-1/2 rounded-full border border-white/20 bg-[#071A2F]/80 px-5 py-3 backdrop-blur-md">

                            <span className="text-[9px] font-bold uppercase tracking-[0.13em] text-white/65">
                                Global
                            </span>

                        </div>

                    </div>


                    {/* CONTENT */}
                    <div className="relative mx-auto flex min-h-[60vh] w-[min(1380px,calc(100%-48px))] items-end pb-20 pt-[190px] max-sm:w-[calc(100%-28px)] lg:min-h-[60vh] lg:pb-24">

                        <div className="max-w-[900px]">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-[#D5AD57]">

                                <span className="h-px w-12 bg-current" />

                                Our Academic Partners

                            </div>


                            <h1 className="mt-7 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(50px,6.5vw,92px)] font-normal leading-[0.96] tracking-[-0.045em]">

                                Partnerships that expand

                                <span className="block text-[#D5AD57]">
                                    the learning horizon.
                                </span>

                            </h1>


                            <p className="mt-8 max-w-[690px] text-[17px] leading-8 text-white/70">

                                ISBM University partners with leading organizations to enhance our educational offerings and create meaningful impact in the field of education.

                            </p>


                            <div className="mt-10 flex flex-wrap gap-x-7 gap-y-4">

                                {[
                                    "Academic Collaboration",
                                    "Global Exposure",
                                    "Research",
                                    "Training",
                                ].map((item, index) => (
                                    <React.Fragment key={item}>

                                        <span className="text-[10px] font-bold uppercase tracking-[0.14em] text-white/65">
                                            {item}
                                        </span>

                                        {index !== 3 && (
                                            <span className="h-1.5 w-1.5 rotate-45 bg-[#D5AD57]" />
                                        )}

                                    </React.Fragment>
                                ))}

                            </div>

                        </div>

                    </div>


                    {/* BOTTOM DESCRIPTOR */}
                    <div className="absolute bottom-0 right-0 hidden border-l border-t border-white/15 bg-[#071A2F]/80 backdrop-blur-md lg:block">

                        <div className="flex items-center gap-8 px-9 py-6">

                            <span className="text-xs font-bold uppercase tracking-[0.16em] text-[#D5AD57]">
                                Partner Network
                            </span>

                            <span className="h-8 w-px bg-white/20" />

                            <span className="text-sm text-white/60">
                                India · Germany · Switzerland · Global
                            </span>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* INTRODUCTION */}
                {/* ====================================================== */}

                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.62fr_1.38fr] lg:gap-24">

                        {/* LEFT */}
                        <div>

                            <Eyebrow>
                                Collaborating for Excellence
                            </Eyebrow>

                            <Title before="Learning Grows Through" highlight="Meaningful Collaboration" after="" position="middle" theme="burgundy" />

                        </div>


                        {/* RIGHT */}
                        <div className="lg:pt-6">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(27px,3vw,42px)] font-normal leading-[1.35] text-[#071A2F]">

                                ISBM University partners with leading organizations to enhance our educational offerings and create meaningful impact in the field of education.

                            </p>


                            <div className="mt-10 grid border-y border-[#071A2F]/15 sm:grid-cols-3">

                                <div className="py-6 sm:border-r sm:border-[#071A2F]/15 sm:px-6">

                                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal text-[#8B1E3F]">
                                        05
                                    </strong>

                                    <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.13em] text-[#071A2F]/55">
                                        Featured Partners
                                    </span>

                                </div>


                                <div className="py-6 sm:border-r sm:border-[#071A2F]/15 sm:px-6">

                                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal text-[#8B1E3F]">
                                        04
                                    </strong>

                                    <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.13em] text-[#071A2F]/55">
                                        Partnership Areas
                                    </span>

                                </div>


                                <div className="py-6 sm:px-6">

                                    <strong className="font-['Libre_Caslon_Display',Georgia,serif] text-[42px] font-normal text-[#8B1E3F]">
                                        01
                                    </strong>

                                    <span className="mt-2 block text-[10px] font-bold uppercase tracking-[0.13em] text-[#071A2F]/55">
                                        Connected Ecosystem
                                    </span>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* PARTNER 01 — ALPHA FOUNDATION */}
                {/* ====================================================== */}

                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.72fr_1.28fr] lg:gap-20">

                            {/* IDENTITY */}
                            <div className="lg:sticky lg:top-[145px] lg:self-start">

                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[70px] font-normal leading-none text-[#8B1E3F]/15">
                                    01
                                </span>


                                <div className="mt-[-10px] flex min-h-[250px] items-center justify-center border border-[#071A2F]/10 bg-white p-10">

                                    <img src={alphaLogo} alt="Alpha Foundation" className="max-h-[150px] max-w-[280px] object-contain" />

                                </div>


                                <div className="mt-5">

                                    <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                        NGO Partner
                                    </span>

                                    <h2 className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[35px] font-normal text-[#071A2F]">
                                        Alpha Foundation
                                    </h2>

                                </div>

                            </div>


                            {/* CONTENT */}
                            <div>

                                <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(25px,3vw,38px)] font-normal leading-[1.4] text-[#071A2F]">

                                    Alpha Foundation is a government registered NGO, determined to funding, footing and sustaining actual grassroots initiatives focused at providing learning and wellbeing to disadvantaged children.

                                </p>


                                <p className="mt-8 text-[15px] leading-8 text-[#65727E]">

                                    In this process, the foundation has achieved position as the first ever grant maker and changing the face of thousands of lives.

                                </p>


                                <p className="mt-6 text-[15px] leading-8 text-[#65727E]">

                                    Alpha Foundation aims at Welfare Reforms for underprivileged children, Social welfare and Health Welfare. It is an Indian NGO for Social Services, Indian Child Welfare Services, Child Education and Self Employment.

                                </p>


                                <div className="mt-10">

                                    <span className="text-[10px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                        Key Focus Areas
                                    </span>


                                    <div className="mt-5 grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                        {partners[0].highlights.map((item, index) => (
                                            <div key={item} className="flex items-center gap-5 bg-white p-5">

                                                <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[20px] text-[#8B1E3F]">
                                                    {String(index + 1).padStart(2, "0")}
                                                </span>

                                                <span className="text-sm font-semibold text-[#071A2F]">
                                                    {item}
                                                </span>

                                            </div>
                                        ))}

                                    </div>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* INTERNATIONAL PARTNERS */}
                {/* ====================================================== */}

                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-11 lg:grid-cols-[1fr_430px] lg:items-end">

                            <div>

                                <Eyebrow>
                                    Academic Collaborations
                                </Eyebrow>

                                <Title before="Partners Across" highlight="Learning & Opportunity" after="" position="middle" theme="burgundy" />

                            </div>


                            <p className="text-[15px] leading-8 text-[#65727E]">
                                Explore the University's academic, training and international collaborations.
                            </p>

                        </div>


                        <div className="mt-14">

                            {partners.slice(1).map((partner, index) => (

                                <article key={partner.number} className="grid gap-8 border-b border-[#071A2F]/15 py-12 first:pt-0 lg:grid-cols-[100px_260px_1fr] lg:gap-10">

                                    {/* NUMBER */}
                                    <div>

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[48px] font-normal leading-none text-[#8B1E3F]/25">
                                            {partner.number}
                                        </span>

                                    </div>


                                    {/* LOGO / IDENTITY */}
                                    <div>

                                        <div className={`flex min-h-[180px] items-center justify-center border border-[#071A2F]/10 p-7 ${index % 3 === 0 ? "bg-[#EEF4F8]" : index % 3 === 1 ? "bg-[#F4E8EC]" : "bg-[#F7F2E8]"}`}>

                                            <img src={partner.logo} alt={partner.name} className="max-h-[110px] max-w-[210px] object-contain" />

                                        </div>


                                        <span className="mt-5 block text-[9px] font-bold uppercase tracking-[0.15em] text-[#8B1E3F]">
                                            {partner.location}
                                        </span>

                                    </div>


                                    {/* CONTENT */}
                                    <div>

                                        <span className="text-[9px] font-bold uppercase tracking-[0.16em] text-[#8B1E3F]">
                                            {partner.category}
                                        </span>


                                        <h3 className="mt-3 max-w-[680px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(29px,3.2vw,42px)] font-normal leading-[1.1] text-[#071A2F]">
                                            {partner.name}
                                        </h3>


                                        <p className="mt-6 max-w-[820px] text-[15px] leading-8 text-[#65727E]">
                                            {partner.intro}
                                        </p>


                                        <div className="mt-8 flex flex-wrap gap-2">

                                            {partner.highlights.map((item) => (
                                                <span key={item} className="border border-[#071A2F]/10 bg-white px-4 py-2.5 text-[9px] font-bold uppercase tracking-[0.11em] text-[#071A2F]/60">
                                                    {item}
                                                </span>
                                            ))}

                                        </div>

                                    </div>

                                </article>

                            ))}

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* PARTNERSHIP MAP STRIP */}
                {/* ====================================================== */}

                <section className="bg-[#071A2F] py-20 text-white sm:py-24">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.55fr_1.45fr] lg:items-center">

                            <div>

                                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#D5AD57]">
                                    Partnership Network
                                </span>

                                <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(36px,4.5vw,56px)] font-normal leading-[1.05]">
                                    Different partnerships.
                                    <span className="block text-[#D5AD57]">
                                        Shared academic purpose.
                                    </span>
                                </h2>

                            </div>


                            <div className="grid border-l border-t border-white/10 sm:grid-cols-2">

                                {[
                                    ["India", "Social & educational initiatives"],
                                    ["Germany", "Academic programmes & knowledge"],
                                    ["Switzerland", "Global business education"],
                                    ["International", "Research, training & academic opportunity"],
                                ].map(([location, text], index) => (
                                    <div key={location} className="border-b border-r border-white/10 p-7">

                                        <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] text-[#D5AD57]">
                                            {String(index + 1).padStart(2, "0")}
                                        </span>

                                        <h3 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[25px] font-normal">
                                            {location}
                                        </h3>

                                        <p className="mt-3 text-[13px] leading-6 text-white/50">
                                            {text}
                                        </p>

                                    </div>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* CLOSING */}
                {/* ====================================================== */}

                <section className="bg-[#F7F2E8] py-20 sm:py-24">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-8 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.75fr_1.25fr] lg:items-center">

                        <div>

                            <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#8B1E3F]">
                                Collaborating for Excellence
                            </span>

                            <h2 className="mt-5 font-['Libre_Caslon_Display',Georgia,serif] text-[38px] font-normal leading-[1.1] text-[#071A2F]">
                                Expanding education through meaningful partnerships.
                            </h2>

                        </div>


                        <p className="max-w-[760px] text-[16px] leading-8 text-[#65727E] lg:justify-self-end">
                            ISBM University's academic collaborations connect students with opportunities in education, research, professional training, international learning and community development.
                        </p>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}